var jade = require("D:\\Git\\projection-grid\\node_modules\\jade\\lib\\runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function ($metadata, columns, hideHeaders, isApplyGroup, isSticky, subSelect, undefined, value) {
jade_mixins["columnHeader"] = jade_interp = function(column, isSubHeader){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if ( column.headerBuilder)
{
buf.push(null == (jade_interp = column.headerBuilder(column, isSubHeader)) ? "" : jade_interp);
}
else
{
if ( column.$orderby)
{
if ( column.$orderby.dir > 0)
{
buf.push("<span class=\"grid-asc\"></span>");
}
else
{
buf.push("<span class=\"grid-des\"></span>");
}
}
if ( (column && column.$html))
{
buf.push(null == (jade_interp = column.$html) ? "" : jade_interp);
}
else
{
if ( isSubHeader && column.config.subColTitle)
{
buf.push(jade.escape(null == (jade_interp = column.config.subColTitle) ? "" : jade_interp));
}
else
{
buf.push(jade.escape(null == (jade_interp = (typeof column.$text != 'undefined')? column.$text : (column.property || column)) ? "" : jade_interp));
}
}
}
};
jade_mixins["th"] = jade_interp = function(column, hasGroup, isSubColumn){
var block = (this && this.block), attributes = (this && this.attributes) || {};
var attr = (column.$metadata || {})['attr.head'] || {}
var colName = column.config && column.config.name || '';
var cls = [];
if ( (colName))
{
cls.push('col-' + colName);
}
if ( column.sortable)
{
cls.push('sortable');
}
if ( column.$orderby)
{
cls.push('orderby');
}
cls = cls.join(' ');
if ( isSubColumn )
{
var colspan = 1, rowspan = 1;
buf.push("<th" + (jade.attrs(jade.merge([{"colspan": jade.escape(colspan),"rowspan": jade.escape(rowspan),"class": (jade_interp = [true], jade.joinClasses([cls].map(jade.joinClasses).map(function (cls, i) {   return jade_interp[i] ? jade.escape(cls) : cls })))},attributes,attr]), true)) + ">");
jade_mixins["columnHeader"](column, true);
buf.push("</th>");
}
else if ( hasGroup && column.groupExpansion)
{
var colspan = column.group.length, rowspan = 1;
buf.push("<th" + (jade.attrs(jade.merge([{"colspan": jade.escape(colspan),"rowspan": jade.escape(rowspan),"class": (jade_interp = [true], jade.joinClasses([cls].map(jade.joinClasses).map(function (cls, i) {   return jade_interp[i] ? jade.escape(cls) : cls })))},attributes,attr]), true)) + "><span class=\"pop-collapse glyphicon glyphicon-minus\"></span><div>");
jade_mixins["columnHeader"](column);
buf.push("</div></th>");
}
else if ( hasGroup && column.group)
{
var colspan = 1, rowspan = 2;
buf.push("<th" + (jade.attrs(jade.merge([{"colspan": jade.escape(colspan),"rowspan": jade.escape(rowspan),"class": (jade_interp = [true], jade.joinClasses([cls].map(jade.joinClasses).map(function (cls, i) {   return jade_interp[i] ? jade.escape(cls) : cls })))},attributes,attr]), true)) + "><span class=\"pop-expand glyphicon glyphicon-plus\"></span><div>");
jade_mixins["columnHeader"](column);
buf.push("</div></th>");
}
else
{
var colspan = 1, rowspan = 2;
buf.push("<th" + (jade.attrs(jade.merge([{"colspan": jade.escape(colspan),"rowspan": jade.escape(rowspan),"class": (jade_interp = [true], jade.joinClasses([cls].map(jade.joinClasses).map(function (cls, i) {   return jade_interp[i] ? jade.escape(cls) : cls })))},attributes,attr]), true)) + ">");
jade_mixins["columnHeader"](column);
buf.push("</th>");
}
};
jade_mixins["td"] = jade_interp = function(row, column){
var block = (this && this.block), attributes = (this && this.attributes) || {};
var attr = (column.$metadata || {})['attr.body'] || {}
var colName = column.config && column.config.name || '';
var cls = colName ? 'col-' + colName : '';
buf.push("<td" + (jade.attrs(jade.merge([{"class": (jade_interp = [true], jade.joinClasses([cls].map(jade.joinClasses).map(function (cls, i) {   return jade_interp[i] ? jade.escape(cls) : cls })))},attributes,attr]), true)) + ">");
var res = row[column.property]
if ( (res && res.$html))
{
buf.push(null == (jade_interp = res.$html) ? "" : jade_interp);
}
else
{
buf.push(jade.escape(null == (jade_interp = res) ? "" : jade_interp));
}
buf.push("</td>");
};
jade_mixins["thead"] = jade_interp = function(isApplyGroup, subSelect, locals, columns){
var block = (this && this.block), attributes = (this && this.attributes) || {};
buf.push("<thead>");
if ( isApplyGroup && subSelect.length === 0)
{
buf.push("<tr class=\"table__row--header\">");
// iterate locals['select'] || []
;(function(){
  var $$obj = locals['select'] || [];
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var columnName = $$obj[$index];

jade_mixins["th"](columns[columnName], true);
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var columnName = $$obj[$index];

jade_mixins["th"](columns[columnName], true);
    }

  }
}).call(this);

buf.push("</tr>");
}
else if ( isApplyGroup)
{
buf.push("<tr class=\"table__row--header\">");
// iterate locals['select'] || []
;(function(){
  var $$obj = locals['select'] || [];
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var columnName = $$obj[$index];

jade_mixins["th"](columns[columnName], true);
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var columnName = $$obj[$index];

jade_mixins["th"](columns[columnName], true);
    }

  }
}).call(this);

buf.push("</tr><tr class=\"table__row--header table__row--sub-header\">");
// iterate locals['subSelect']
;(function(){
  var $$obj = locals['subSelect'];
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var columnName = $$obj[$index];

jade_mixins["th"](columns[columnName], true, true);
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var columnName = $$obj[$index];

jade_mixins["th"](columns[columnName], true, true);
    }

  }
}).call(this);

buf.push("</tr>");
}
else
{
buf.push("<tr class=\"table__row--header\">");
// iterate locals['select'] || []
;(function(){
  var $$obj = locals['select'] || [];
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var columnName = $$obj[$index];

jade_mixins["th"](columns[columnName]);
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var columnName = $$obj[$index];

jade_mixins["th"](columns[columnName]);
    }

  }
}).call(this);

buf.push("</tr>");
}
buf.push("</thead>");
};
if ( isSticky)
{
buf.push("<table" + (jade.attrs(jade.merge([{"class": "table table-hover grid grid-sticky-header"},$metadata || {}]), true)) + ">");
jade_mixins["thead"](isApplyGroup, subSelect, locals, columns);
buf.push("</table><div class=\"sticky-header-filler\"></div>");
}
buf.push("<table" + (jade.attrs(jade.merge([{"role": "grid","class": "table table-hover grid grid-content"},$metadata || {}]), true)) + ">");
if ( !hideHeaders && !isSticky)
{
jade_mixins["thead"](isApplyGroup, subSelect, locals, columns);
}
buf.push("<tbody>");
// iterate value
;(function(){
  var $$obj = value;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var row = $$obj[i];

var attr = (row.$metadata || {}).attr || {}
buf.push("<tr" + (jade.attrs(jade.merge([{"class": "table__row--body"},attr]), true)) + ">");
// iterate locals['selectExpand'] || locals.select
;(function(){
  var $$obj = locals['selectExpand'] || locals.select;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var columnName = $$obj[$index];

jade_mixins["td"](row, columns[columnName]);
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var columnName = $$obj[$index];

jade_mixins["td"](row, columns[columnName]);
    }

  }
}).call(this);

buf.push("</tr>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var row = $$obj[i];

var attr = (row.$metadata || {}).attr || {}
buf.push("<tr" + (jade.attrs(jade.merge([{"class": "table__row--body"},attr]), true)) + ">");
// iterate locals['selectExpand'] || locals.select
;(function(){
  var $$obj = locals['selectExpand'] || locals.select;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var columnName = $$obj[$index];

jade_mixins["td"](row, columns[columnName]);
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var columnName = $$obj[$index];

jade_mixins["td"](row, columns[columnName]);
    }

  }
}).call(this);

buf.push("</tr>");
    }

  }
}).call(this);

buf.push("</tbody></table>");}.call(this,"$metadata" in locals_for_with?locals_for_with.$metadata:typeof $metadata!=="undefined"?$metadata:undefined,"columns" in locals_for_with?locals_for_with.columns:typeof columns!=="undefined"?columns:undefined,"hideHeaders" in locals_for_with?locals_for_with.hideHeaders:typeof hideHeaders!=="undefined"?hideHeaders:undefined,"isApplyGroup" in locals_for_with?locals_for_with.isApplyGroup:typeof isApplyGroup!=="undefined"?isApplyGroup:undefined,"isSticky" in locals_for_with?locals_for_with.isSticky:typeof isSticky!=="undefined"?isSticky:undefined,"subSelect" in locals_for_with?locals_for_with.subSelect:typeof subSelect!=="undefined"?subSelect:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined,"value" in locals_for_with?locals_for_with.value:typeof value!=="undefined"?value:undefined));;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./js/layout/template/table.jade
// module id = 9
// module chunks = 0